import { render } from "./WpeShare.vue?vue&type=template&id=4660fa59"
import script from "./WpeShare.vue?vue&type=script&lang=js"
export * from "./WpeShare.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/templates/WpeShare.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4660fa59"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4660fa59', __exports__)) {
    api.reload('4660fa59', __exports__)
  }
  
  module.hot.accept("./WpeShare.vue?vue&type=template&id=4660fa59", () => {
    api.rerender('4660fa59', render)
  })

}


export default __exports__